const Constants = {
	storageAccessToken: 'storageAccessToken',
	storageOnboardingDone: 'storageOnboardingDone',
	storageLanguage: 'storageLanguage',
	storageUser: 'storageUser',
	storageChunkReloaded: 'storageChunkReloaded',
	legacyStorageAuthToken: 'authToken',
	legacyStorageOnboardingDone: 'onboardingDone',
	legacyStorageLanguage: 'language',
	eventAuthOnLogOut: 'AuthEventOnLogOut',
	environmentLocal: 'local',
	environmentDevelopment: 'development',
	environmentFeature: 'feature',
	environmentAcceptance: 'acceptance',
	environmentProduction: 'production',
	platformIos: 'ios',
	platformAndroid: 'android',
	platformWeb: 'web',
	platformMacos: 'macos',
	platformWindows: 'windows',
	appStateEventChange: 'change',
	keyboardEventDidShow: 'keyboardDidShow',
	keyboardEventDidHide: 'keyboardDidHide',
	domEventFocus: 'focus',
	domEventTransitionEnd: 'transitionend',
	webSplashId: 'web-splash',
	webSplashHiddenClass: 'web-splash--hidden',
	webSplashRegionClass: 'web-splash__region',
	cssPropertyBottom: 'bottom',
	cssPropertyOpacity: 'opacity',
	appStateActive: 'active',
	appStateBackground: 'background',
	appOwnershipExpo: 'expo',
	localeNl: 'nl',
	localeDe: 'de',
	localeEn: 'en',
	localeFr: 'fr',
	navigatorAuth: 'Auth',
	navigatorBottomTab: 'Root',
	navigatorMain: 'StackRoot',
	navigatorMessages: 'Messages',
	screenTabHome: 'Home',
	screenTabBooking: 'Reserveren',
	screenTabLoyalty: 'Loyaliteit',
	screenTabInspiration: 'Ontspanning',
	screenTabBathCard: 'Badenkaart',
	screenTabAccount: 'Account',
	screenReservationDetail: 'ReservationDetail',
	screenTutorial: 'Tutorial',
	screenLogin: 'Login',
	screenOnboarding: 'Onboarding',
	screenHome: 'HomeScreen',
	screenResort: 'Resort',
	screenReserve: 'Reserve',
	screenLoyalty: 'Loyalty',
	screenLoyaltyResort: 'LoyaltyResort',
	screenInspiration: 'Inspiration',
	screenBathCardsList: 'BathCardsList',
	screenMessagesIndex: 'MessagesIndex',
	screenMessageDetail: 'MessageDetail',
	screenAccountDetail: 'AccountDetail',
	screenUpcomingReservations: 'UpcomingReservations',
	screenPastReservations: 'PastReservations',
	screenPreferences: 'Preferences',
	screenNotificationPreferences: 'NotificationPreferences',
	screenMailPreferences: 'MailPreferences',
	screenLanguagePreferences: 'LanguagePreferences',
	screenProfile: 'Profile',
	screenEditProfile: 'EditProfile',
	screenEditAddress: 'EditAddress',
	bridgeChannel: 'my-thermen',
	bridgeMessageRedirect: 'redirect',
	bridgeMessageReservationFlowOpen: 'reservation-flow.open',
	bridgeEventAuthenticate: 'my-thermen.authenticate',
	radioStatusChecked: 'checked',
	radioStatusUnchecked: 'unchecked',
	deviceNameUnknown: 'unknown',
	dateFormatServer: 'YYYY-MM-DD',
	dateFormatServerDateTime: 'YYYY-MM-DD HH:mm:ss',
	dateFormatDisplayNumeric: 'DD-MM-YYYY',
	dateFormatDisplaySpaced: 'DD - MM - YYYY',
	dateFormatDisplayShort: 'D MMM YYYY',
	dateFormatDisplayShortPadded: 'DD MMM YYYY',
	dateFormatDisplayLong: 'DD MMMM Y',
	dateFormatDayMonthShort: 'DD MMM',
	dateFormatDayMonthLong: 'DD MMMM',
	dateFnsFormatMonthYear: 'MMMM yyyy',
	dateFnsFormatServer: 'yyyy-MM-dd',
	dateFnsFormatYearMonth: 'yyyy-MM',
	dateFnsFormatYear: 'yyyy',
	dateFnsFormatMonth: 'MM',
	dateFnsFormatWeekdayNarrow: 'EEEEEE',
	genderFemale: 'female',
	genderMale: 'male',
	genderOther: 'other',
	profileFieldBirthDate: 'birth_date',
	profileFieldTypeDate: 'date',
	profileFieldTypeNum: 'num',
	profileFieldTypeRadio: 'radio',
	profileFieldTypeSelect: 'select',
	gaOriginPrefix: 'Mijn-',
	gaOriginPlatformIos: 'iOS',
	gaOriginPlatformAndroid: 'Android',
	loyaltyStatusIcon0: 'status0',
	loyaltyStatusIcon1: 'status1',
	loyaltyStatusIcon2: 'status2',
	loyaltyStatusIcon3: 'status3',
	loyaltyStatusIconBathCard: 'bathcard',
	toastTypeSuccess: 'success',
	workspacesDefaultItemValue: '-1',
	selectFieldStyleElementId: 'selectfield-style',
	selectFieldWebResetCss: 'select { -webkit-appearance: none; appearance: none; outline: none; }',
	apiHeaderAccept: 'Accept',
	apiHeaderAcceptLanguage: 'Accept-Language',
	apiHeaderAuthorization: 'Authorization',
	apiHeaderContentType: 'Content-Type',
	apiHeaderXAppVersion: 'X-APP-VERSION',
	apiHeaderXChannel: 'X-Channel',
	apiHeaderXToken: 'X-Token',
	apiHeaderValueApplicationJson: 'application/json',
	apiChannel: 'thermenresorts',
	paramsAccessToken: 'access_token',
	paramsBathCardId: 'bath_card_id',
	paramsFilterHistorical: 'filter[historical]',
	paramsFilterUpcoming: 'filter[upcoming]',
	paramsGaOrigin: 'ga_origin',
	paramsLanguage: 'lang',
	paramsMessageId: 'message_id',
	paramsOrigin: 'origin',
	paramsReservationId: 'reservation_id',
	paramsUtmMedium: 'utm_medium',
	paramsUtmPrefix: 'utm_',
	paramsUtmSource: 'utm_source',
	utmMediumApp: 'app',
	categoryFilterAll: 0,
	badgeMaxCount: 99,
	nextTickDelay: 1,
	apiTimeout: 10_000,
	apiTimeoutReservations: 30_000,
	reservationsPageSize: 50,
	httpStatusOk: 200,
	httpStatusUnauthorized: 401,
	httpStatusNotFound: 404,
	httpStatusUnprocessableEntity: 422,
	httpStatusTooManyRequests: 429,
	validationFieldReplyMessage: 'reply_message',
	validationFieldPassword: 'password',
	barcodeFormatCode128: 'CODE128',
	barcodeFormatEan13: 'EAN13',
	analyticsEventAddBathcard: 'add_bathcard',
	analyticsEventChangeAccountSettings: 'change_account_settings',
	analyticsEventChangeOptinSettings: 'change_optin_settings',
	analyticsEventDeleteAccount: 'delete_account',
	analyticsEventLogin: 'login',
	analyticsEventLogout: 'logout',
	analyticsEventPageView: 'page_view',
	analyticsEventScreenView: 'screen_view',
	analyticsEventSignUp: 'sign_up',
	analyticsParamPlatform: 'platform_mijn',
	analyticsParamScreenClass: 'screen_class',
	analyticsParamScreenName: 'screen_name',
	analyticsParamScreenPage: 'screen_page',
	analyticsParamSelectItem: 'select_item',
	analyticsParamUserId: 'user_id',
	analyticsUserPropertyBathcard: 'bathcard',
	analyticsUserPropertyLoyaltyStatus: 'loyalty_status',
	analyticsValueSelectItemAddressData: 'adresgegevens',
	analyticsValueSelectItemLanguagePrefix: 'Voorkeurstaal: ',
	analyticsValueSelectItemNotificationsPrefix: 'notificaties: ',
	analyticsValueSelectItemPassword: 'wachtwoord',
	analyticsValueSelectItemPersonalData: 'persoonsgegevens',
	analyticsValueToggleOn: 'aan',
	analyticsValueToggleOff: 'uit',
	deeplinkAuthPath: 'auth',
	deeplinkLoginPath: 'login',
	deeplinkAppPaths: ['mijn', 'my', 'mein', 'mon'],
	deeplinkMagicLinkParam: 'magiclink',
	urlYoutubeEmbed: 'https://www.youtube.com/embed/',
	sentryDsn: 'https://34844b98414361a8d7b9b35729ed0b96@o398254.ingest.sentry.io/4506579644514305',
	allowedExternalUrlSchemes: ['http:', 'https:', 'mailto:', 'tel:'] as readonly string[],
	webUrlSchemes: ['http:', 'https:'] as readonly string[],
} as const;

export default Constants;
